import * as React from "react";

import ClassNames from "classnames";
import InputLabel from "../InputLabel";
import Typography from "../Typography";
import Styles from "./TextArea.module.css";

export interface Props {
  id: string;
  name?: string;
  className?: string;
  defaultValue?: string;
  placeholder?: string;
  row?: number;
  column?: number;
  hideLabel?: boolean;
  label: string;
  errors?: string[];
  helperText?: string;
  helperClass?: string;
  required?: boolean;
  nativeRequired?: boolean;
  disabled?: boolean;
  inputRef?: any;
  value?: string;
}

const TextArea: React.FC<Props> = props => {
  const {
    id,
    name,
    className,
    defaultValue,
    helperClass,
    placeholder,
    hideLabel,
    label,
    errors,
    helperText,
    required,
    nativeRequired,
    disabled,
    inputRef,
    value,
    row = 6,
    column = 33
  } = props;

  return (
    <div className={Styles.wrapper}>
      <InputLabel
        label={label}
        htmlFor={id}
        required={required}
        nativeRequired={nativeRequired}
        hideLabel={hideLabel}
      />
      <textarea
        id={id}
        name={name}
        className={ClassNames({
          [Styles.field]: true,
          [className]: className
        })}
        placeholder={placeholder}
        rows={row}
        cols={column}
        disabled={disabled}
        required={nativeRequired}
        ref={inputRef}
        value={value}
        defaultValue={defaultValue}
      />
      {helperText && (
        <Typography
          body="small"
          className={`${Styles.helper} ${helperClass || ""}`}
        >
          {helperText}
        </Typography>
      )}
      {errors &&
        errors.map((error, i) => {
          return (
            <Typography
              body="small"
              className={ClassNames({
                [Styles.error]: true,
                [Styles.firstError]: errors.length !== 1 && i === 0
              })}
              key={`error-${id}-${i}`}
            >
              {error}
            </Typography>
          );
        })}
    </div>
  );
};

export default TextArea;
